import { Add, Delete, Edit, Flag } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Avatar, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Paper, Select, SwipeableDrawer, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
import Div from '@jumbo/shared/Div';
const validationSchema = yup.object({
  role: yup.string().required('Role is required'), // Ensure role is defined first
  name: yup.string().required('Name is required'),
  user_name: yup.string().required('Username is required'),
  password: yup.string().required('Password is required'),
  branches: yup.array().of(yup.string()).min(1, 'At least one branch is required').required('Branches are required'),

});

const AddUser = () => {
  const [users,setUsers] = useState([])
  const [roles, setRoles] = useState([]); 
  const [branchesData, setBranchesData] = useState([]); 
  const [helperData, setHelperData] = useState({}); 
  const [drawer,setDrawer] = useState(false)
  const [searchUserDialoge,setSearchUserDialoge] = useState(false)
  const [loading,setLoading] = useState(false)
  const {rights} = useJumboAuth();
  // console.log(rights);
  const swal = useSwalWrapper();

  const formik = useFormik({
    initialValues: {
      name: '',
      user_name: '',
      password: '',
      branches: [],
      role: '',
      FL_PARTY_ID:'',
      FL_EMAIL:'',
      FL_PHONE:'',
      FL_BU_COMPANY_NAME:'',
      FL_COUNTRY:'',
      FL_CITY:'',
      FL_PIN:'',
      FL_ADD:'',
      FL_IS_ACTIVE:0,
      FL_IS_APPROVE:''
    },
    validationSchema: validationSchema,
    onSubmit: async(values) => {
      setLoading(true)
      if(values.id){
        if(values.role == 4 && !values.FL_PARTY_ID) {alert('Please Select Party');setLoading(false);return}
        await jwtAuthAxios.post(`user/edituser/${values.id}`,values).then(data =>{
          // console.log(data.data);
          if(data.data.status == "succes"){
            fetchUserData()
            setDrawer(false)
            swal.fire({
              icon:'success',
              text:data.data.message,
            })
          } else{
            swal.fire({
              icon:'error',
              text:'something Went Wrong',
            })            
          }
          setLoading(false)
        }).catch(()=>{setLoading(false)})
      } else{
        await jwtAuthAxios.post(`user/adduser`,values).then(data =>{
          if(data.data.status == "succes"){
            fetchUserData()
            setDrawer(false)
            swal.fire({
              icon:'success',
              text:data.data.message,
            })
          } else{
            swal.fire({
              icon:'error',
              text:'something Went Wrong',
            })            
          }
          setLoading(false)
        }).catch(()=>{setLoading(false)})

      }
    },
  });
  

  useEffect(() => {
    // Fetch roles from the API using jwtAuthAxios
    jwtAuthAxios.get('roleMenu/roles').then((response) => {
      setRoles(response.data);
    });
    jwtAuthAxios.get('branch').then((response) => {
      setBranchesData(response.data);
    });
    jwtAuthAxios.get('master/helper?party=1').then((response) => {
      // console.log(response.data.data);
      setHelperData(response.data.data);
    });
  }, []);
  const fetchUserData = async (searchData) => {
    try {
      setUsers([])
      const { data } = await jwtAuthAxios.post('user/users',searchData);
      setUsers(data);
    } catch (error) {
      // Handle errors here
    }
  };
  const userActiveInactiveHandler = async (value) => {
    try {
        const confirmed = window.confirm('Are you sure?');
        if (confirmed) {
            await jwtAuthAxios.post('user/userActive/' + value.id, value).then((data)=>{
              if (data.data.status === "succes") {
                fetchUserData();
                swal.fire({
                  icon: 'success',
                  text: data.data.message,
                });
              } else {
                swal.fire({
                  icon: 'error',
                  text: 'Something went wrong',
                });
              }
            })
            }
    } catch (error) {
        // Handle errors here
        swal.fire({
            icon: 'error',
            text: error, // Assuming error has a message property
        });
    }
};

  useEffect(async()=>{
    setSearchUserDialoge(true);
  },[])
  useEffect(async()=>{
    if(drawer == false){
      formik.resetForm()
    }
  },[drawer])
  const userEditHandler =(user)=>{
    formik.setFieldValue("name",user?.FL_NAME)
    formik.setFieldValue("id",user?.FL_USER_ID)
    formik.setFieldValue("user_name",user?.FL_USER_NAME)
    formik.setFieldValue("password",user?.FL_PASSWORD)
    formik.setFieldValue("role",user?.FL_ROLE_ID == null? [] : user?.FL_ROLE_ID)
    formik.setFieldValue("branches",user?.BRANCHES == null? []:user?.BRANCHES.split(','))
    formik.setFieldValue("FL_EMAIL",user?.FL_EMAIL)
    formik.setFieldValue("FL_PHONE",user?.FL_PHONE)
    formik.setFieldValue("FL_PARTY_ID",user?.FL_PARTY_ID)
    formik.setFieldValue("FL_BU_COMPANY_NAME",user?.FL_BU_COMPANY_NAME)
    formik.setFieldValue("FL_COUNTRY",user?.FL_COUNTRY)
    formik.setFieldValue("FL_CITY",user?.FL_CITY)
    formik.setFieldValue("FL_PIN",user?.FL_PIN)
    formik.setFieldValue("FL_ADD",user?.FL_ADD)
    formik.setFieldValue("FL_IS_ACTIVE",user?.FL_IS_ACTIVE)
    // formik.setFieldValue("FL_SALES_PERSON_ID",user?.FL_SALES_PERSON_ID)
    formik.setFieldValue("FL_IS_APPROV",user?.FL_IS_APPROV)
    setDrawer(true) 
  }
  return (<div><Div  sx={{display: 'flex',margin: '0 0px 22px auto',justifyContent: 'end',gap: '15px'}}><LoadingButton   variant="contained" onClick={()=>setSearchUserDialoge(true)} startIcon={<FilterAltIcon/> }  color="primary">
  Filter
</LoadingButton>
{rights?.insert==1&&  <LoadingButton variant="contained" onClick={()=>setDrawer(true)}  startIcon={<Add/> }  color="primary">
         Add User
      </LoadingButton>}</Div>
      {users.length >0 ? 
      <TableContainer  component={Paper}>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell>Icon</TableCell>
              <TableCell>User name</TableCell>
              <TableCell>name</TableCell>
              <TableCell>Branches/party</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Is active</TableCell>
              {/* <TableCell>Is Approved</TableCell> */}
              <TableCell align='right'>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {users.map((user,index)=>{
            let data = user.FL_NAME[0]
             return(<TableRow key={index}>
              <TableCell>
              <Avatar
                    sx={{background: user?.FL_ROLE_ID == 4?'info':'primary'}}
                    alt={data}
                >
                  {data}
                </Avatar>
              </TableCell>

              <TableCell>{user.FL_USER_NAME}</TableCell>
              <TableCell>{user.FL_NAME}</TableCell>

              <TableCell>{user?.FL_ROLE_ID != 4 ? user?.BRANCHES?.split(',')?.map((item,i)=>{return <Chip
              key={i}
              color={user.FL_IS_ACTIVE == 1?"success":"error"}
              variant='outlined'
              sx={{mx:0.5}}
                label={item}
            />}):user.FL_PARTY_ID && <Chip
            color={user.FL_IS_ACTIVE == 1?"info":"error"}
            variant='outlined'
            sx={{mx:0.5}}
              label={helperData?.PARTY?.filter(s=> s.FL_PARTY_CODE== user.FL_PARTY_ID)[0]?.FL_PARTY_NAME}
          />}</TableCell>
              <TableCell>{user.FL_ROLE_NAME}</TableCell>
              <TableCell>
              <Chip
              color={user.FL_IS_ACTIVE == 1?"success":"error"}
                label={user.FL_IS_ACTIVE == 1?"Active":"Inactive"}
                disabled ={user.FL_ROLE_ID ==4 && !user.FL_PARTY_ID}
                onClick={() =>rights?.edit ==1 && userActiveInactiveHandler({id:user.FL_USER_ID,value:user.FL_IS_ACTIVE == 1?0:1})}

            />
              </TableCell>
              {/* <TableCell>
              <Chip
              color={user.FL_IS_APPROVE == 'Y'?"success":"error"}
              variant='outlined'
                label={user.FL_IS_APPROVE == 'Y'?"Approved":"Unapproved"}
                onClick={() =>(rights?.edit ==1 && user.FL_IS_APPROVE != 'Y') && userActiveInactiveHandler({id:user.FL_USER_ID,value:'Y'})}

            />
              </TableCell> */}
              <TableCell align='right'>
              {rights?.edit ==1&& <Chip
              color={"error"}
              onClick={()=>userEditHandler(user)}
              icon={<Edit fontSize='18px'/>}
              label="edit"

            />}
              </TableCell>
            </TableRow>)
          })}
          </TableBody>
        </Table>
      </TableContainer> :<TableSkeleton cols={7} />}
      <SwipeableDrawer
      anchor="right"      
      open={drawer}
      onClose={()=>setDrawer(false)}
      onOpen={()=>setDrawer(true)}
    >
      <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minWidth: '500px',
        margin: '0 auto',
        p:3
      }}
      onSubmit={formik.handleSubmit}
    >
      <h3 style={{padding:'5px',marginTop:'0'}}>User</h3>
      <TextField
        label="Name"
        variant="outlined"
        sx={{mb:0}}
        margin="normal"
        size='small'
        fullWidth
        autoFocus
        {...formik.getFieldProps('name')}
        error={formik.touched.name && Boolean(formik.errors.name)}
        helperText={formik.touched.name && formik.errors.name}
      />
      <TextField
        label="Username"
        variant="outlined"
        margin="normal"
        size='small'
        sx={{mb:0}}
        fullWidth
        {...formik.getFieldProps('user_name')}
        error={formik.touched.user_name && Boolean(formik.errors.user_name)}
        helperText={formik.touched.user_name && formik.errors.user_name}
      />
      <TextField
        label="Password"
        type="password"
        size='small'
        sx={{mb:0}}
        variant="outlined"
        margin="normal"
        fullWidth
        {...formik.getFieldProps('password')}
        error={formik.touched.password && Boolean(formik.errors.password)}
        helperText={formik.touched.password && formik.errors.password}
      />
       {/* Branches Selection (Multi-Select) */}
       <FormControl variant="outlined" fullWidth margin="normal">
        <InputLabel size='small' id="role-label">Role</InputLabel>
        <Select
          labelId="role-label"
          label="Role"
          sx={{mb:0}}
          size='small'
          {...formik.getFieldProps('role')}
          error={formik.touched.role && Boolean(formik.errors.role)}
          helperText={formik.touched.role && formik.errors.role}
        >
          {roles.length == 0 && <MenuItem value="">
            <em>None</em>
          </MenuItem>}
          {roles.map((role) => (
            <MenuItem key={role.FL_ROLE_ID} value={role.FL_ROLE_ID}>
              {role.FL_ROLE_NAME}
            </MenuItem>
          ))}
        </Select>
       {(formik.touched.role && formik.errors.role) && <p className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained css-1qhtpql-MuiFormHelperText-root">{formik.touched.role && formik.errors.role}</p>}
      </FormControl>
        <FormControl variant="outlined" fullWidth margin="normal">
        <InputLabel id="branches-label" size='small' >Branches</InputLabel>
        <Select
          labelId="branches-label"
          id="branches"
          size='small'
          sx={{mb:0}}
          multiple
          label="Branches"
          {...formik.getFieldProps('branches')}
          error={formik.touched.branches && Boolean(formik.errors.branches)}
          renderValue={(selected) => (
            <div>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </div>
          )}
        >
          {branchesData?.map((branch) => (
            <MenuItem key={branch.FL_BRANCH_CODE} value={branch.FL_BRANCH_CODE}>
              {branch.FL_BRANCH_CODE}
            </MenuItem>
          ))}
        </Select>
        {(formik.touched.branches && formik.errors.branches) && <p className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained css-1qhtpql-MuiFormHelperText-root">{formik.touched.branches && formik.errors.branches}</p>}
      </FormControl> 
      {formik.values.role == 4 &&
       <><FormControl variant="outlined" fullWidth margin="normal">
       <InputLabel id="Party-label" size='small' >Party</InputLabel>
       <Select
         labelId="Party-label"
         id="Party"
         size='small'
         sx={{mb:0}}
         label="FL_PARTY_ID"
         {...formik.getFieldProps('FL_PARTY_ID')}
         error={formik.touched.FL_PARTY_ID && Boolean(formik.errors.FL_PARTY_ID)}
        //  renderValue={(selected) => (
        //    <div>
        //      {selected.map((value) => (
        //        <Chip key={value} label={value} />
        //      ))}
        //    </div>
        //  )}
       >
         {helperData?.PARTY?.map((party) => (
           <MenuItem key={party.FL_PARTY_CODE} value={party.FL_PARTY_CODE}>
             {party.FL_PARTY_NAME}
           </MenuItem>
         ))}
       </Select>
       {(formik.touched.Party && formik.errors.Party) && <p className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained css-1qhtpql-MuiFormHelperText-root">{formik.touched.Party && formik.errors.Party}</p>}
     </FormControl></>
      }
      
      <TextField
        label="Email"
        type="email"
        size='small'
        sx={{mb:0}}
        variant="outlined"
        margin="normal"
        fullWidth
        {...formik.getFieldProps('FL_EMAIL')}
        error={formik.touched.FL_EMAIL && Boolean(formik.errors.FL_EMAIL)}
        helperText={formik.touched.FL_EMAIL && formik.errors.FL_EMAIL}
      />
      <TextField
        label="Phone"
        variant="outlined"
        size='small'
        sx={{mb:0}}
        margin="normal"
        fullWidth
        {...formik.getFieldProps('FL_PHONE')}
        error={formik.touched.FL_PHONE && Boolean(formik.errors.FL_PHONE)}
        helperText={formik.touched.FL_PHONE && formik.errors.FL_PHONE}
      />
      <TextField
        label="Company Name"
        variant="outlined"
        size='small'
        sx={{mb:0}}
        margin="normal"
        fullWidth
        {...formik.getFieldProps('FL_BU_COMPANY_NAME')}
        error={formik.touched.FL_BU_COMPANY_NAME && Boolean(formik.errors.FL_BU_COMPANY_NAME)}
        helperText={formik.touched.FL_BU_COMPANY_NAME && formik.errors.FL_BU_COMPANY_NAME}
      />
      <TextField
        label="Country"
        variant="outlined"
        margin="normal"
        size='small'
        sx={{mb:0}}
        fullWidth
        {...formik.getFieldProps('FL_COUNTRY')}
        error={formik.touched.FL_COUNTRY && Boolean(formik.errors.FL_COUNTRY)}
        helperText={formik.touched.FL_COUNTRY && formik.errors.FL_COUNTRY}
      />
      <TextField
        label="City"
        size='small'
        sx={{mb:0}}
        variant="outlined"
        margin="normal"
        fullWidth
        {...formik.getFieldProps('FL_CITY')}
        error={formik.touched.FL_CITY && Boolean(formik.errors.FL_CITY)}
        helperText={formik.touched.FL_CITY && formik.errors.FL_CITY}
      />
      <TextField
        label="Pin"
        variant="outlined"
        size='small'
        sx={{mb:0}}
        margin="normal"
        fullWidth
        {...formik.getFieldProps('FL_PIN')}
        error={formik.touched.FL_PIN && Boolean(formik.errors.FL_PIN)}
        helperText={formik.touched.FL_PIN && formik.errors.FL_PIN}
      />
      <TextField
        label="Add"
        variant="outlined"
        size='small'
        sx={{mb:0}}
        margin="normal"
        fullWidth
        {...formik.getFieldProps('FL_ADD')}
        error={formik.touched.FL_ADD && Boolean(formik.errors.FL_ADD)}
        helperText={formik.touched.FL_ADD && formik.errors.FL_ADD}
      />
      <FormControl variant="outlined" fullWidth margin="normal">
        <InputLabel size='small' id="role-label">Active</InputLabel>
        <Select
          labelId="role-label"
          label="Role"
          sx={{mb:0}}
          size='small'
          {...formik.getFieldProps('FL_IS_ACTIVE')}
          error={formik.touched.FL_IS_ACTIVE && Boolean(formik.errors.FL_IS_ACTIVE)}
          helperText={formik.touched.FL_IS_ACTIVE && formik.errors.FL_IS_ACTIVE}
        >
         <MenuItem value="0">
            inActive
          </MenuItem>
            <MenuItem value="1">
            Active
            </MenuItem>
        </Select></FormControl>
        {console.log(formik)}
      <LoadingButton
      loading={loading}
        type="submit"
        variant="contained"
        color="primary"
        sx={{ marginTop: '16px' }}
      >
        Submit
      </LoadingButton>
    </Box>
    </SwipeableDrawer>
    <MyUserFilterDialogForm open={searchUserDialoge} helperData={helperData} setOpen={setSearchUserDialoge} roles={roles} callback={fetchUserData}/>
    </div>
  )
};
const MyUserFilterDialogForm = ({open, setOpen,helperData,roles,callback}) => {
  // const [open, setOpen] = useState(false);
  const [searchData, setSearchData] = useState({
    email: '',
    fromDate: '',
    toDate: '',
    party:'',
    role: '',
  });


  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setSearchData({ ...searchData, [name]: value });
  };

  const handleSubmit = () => {
    // Handle form submission here
    // console.log(searchData);
    callback(searchData)
    handleClose();
  };

  return (
    <div>
      {/* <Button variant="outlined" onClick={handleOpen}>Open Form</Button> */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>User Search</DialogTitle>
        <DialogContent>
        <FormControl fullWidth margin="dense">
            <InputLabel id="role-label">Role</InputLabel>
            <Select
              labelId="role-label"
              label="Role"
              name="role"
              value={searchData.role}
              onChange={handleChange}
            >
              <MenuItem value="">Select Role</MenuItem>
              {roles.map(r=><MenuItem value={r.FL_ROLE_ID}>{r.FL_ROLE_NAME}</MenuItem>)}
            </Select>
          </FormControl>
          <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              margin="dense"
              label="From Date"
              type="date"
              fullWidth
              name="fromDate"
              value={searchData.fromDate}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
                      </Grid>
          <Grid item xs={6}>

          <TextField
            margin="dense"
            label="To Date"
            type="date"
            fullWidth
            name="toDate"
            value={searchData.toDate}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            />
          </Grid>
          </Grid>
          <FormControl fullWidth margin="dense">
            <InputLabel id="role-label">Party</InputLabel>
            <Select
              labelId="role-label"
              label="Party"
              name="party"
              value={searchData.party}
              onChange={handleChange}
            >
              <MenuItem value="">Select Party</MenuItem>
              {helperData?.PARTY?.map((party) => (
                <MenuItem key={party.FL_PARTY_CODE} value={party.FL_PARTY_CODE}>
                  {party.FL_PARTY_NAME}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <TextField
            autoFocus
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            name="email"
            value={searchData.email}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant='outlined' color="error">Cancel</Button>
          <Button onClick={handleSubmit} variant='outlined'  color="primary">Search</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

AddUser.Modulename='USER';
export default AddUser;
